import { IGSTConfig, ISegmentConfigData } from './type';

export const hydrateFormData = (data: IGSTConfig): ISegmentConfigData => {
	const hydratedData: ISegmentConfigData = {} as ISegmentConfigData;
	hydratedData.segmentName = data.segmentName;
	hydratedData.dailyLimit = data.dailyLimit?.toLocaleString('en-IN');
	hydratedData.overAllLimit = data.overAllLimit?.toLocaleString('en-IN');
	return hydratedData;
};

export const dehydrateFormData = (data: ISegmentConfigData): IGSTConfig => {
	const conversionConfig: IGSTConfig = {} as IGSTConfig;
	conversionConfig.segmentName = data.segmentName;
	conversionConfig.dailyLimit = Number(data?.dailyLimit?.replace(/,/g, ''));
	conversionConfig.overAllLimit = Number(data?.overAllLimit?.replace(/,/g, ''));
	return conversionConfig;
};
